export // 第一个参数是需要进行防抖处理的函数，第二个参数是延迟时间，默认为1秒钟
function debounce(fn: any, delay = 1000) {
  // 实现防抖函数的核心是使用setTimeout
  // time变量用于保存setTimeout返回的Id
  let time: any = null;

  // 将回调接收的参数保存到args数组中
  const _debounce = (...args: any) => {
    // 如果time不为0，也就是说有定时器存在，将该定时器清除
    if (time !== null) {
      clearTimeout(time);
    }

    time = setTimeout(() => {
      fn();
    }, delay);
  };

  // 防抖函数会返回另一个函数，该函数才是真正被调用的函数
  return _debounce;
}

export function getQueryString(name: string): string | null {
  const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  const r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

/**
 * 格式化百分比
 * 0.5213 => 52.13%
 */
export const formatPercentage = (num: number): string => {
  const percentage = Math.round(num * 10000) / 100;
  return Number.isNaN(percentage) ? "-" : `${percentage}%`;
};

export const numToMoney = (num: number): string => {
  if (+num === 0) return "0";
  if (!num) {
    return "-";
  }
  return num.toLocaleString("zh", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
};
export const exportBlob = (ioData: BlobPart, name: any) => {
  const blob = new Blob([ioData]); // 构造一个blob对象来处理数据
  const fileName = name;
  // IE10以上支持blob但是依然不支持download
  if ("download" in document.createElement("a")) {
    // 支持a标签download的浏览器
    const link = document.createElement("a"); // 创建a标签
    link.download = fileName; // a标签添加属性
    link.style.display = "none";
    link.href = URL.createObjectURL(blob);
    document.body.appendChild(link);
    link.click(); // 执行下载
    URL.revokeObjectURL(link.href); // 释放url
    document.body.removeChild(link); // 释放标签
  } else {
    // 其他浏览器
    navigator.msSaveBlob(blob, fileName);
  }
};
/**
 * 数字千分符格式化
 * @param num 待格式化的数字或数字字符串（支持整数、小数）
 * @param decimalDigits 保留的小数位数（可选，默认保留所有小数）
 * @returns 格式化后的字符串，格式错误时返回原值
 */
export const formatThousands = (
  num: number | string,
  decimalDigits?: number
): string => {
  // 处理空值或非数字情况
  if (num === null || num === undefined || num === "") return String(num);

  // 转换为字符串，统一处理
  const strNum = String(num);

  // 匹配数字格式（整数、小数、正负号）
  const reg = /^([+-]?)(\d+)(\.?\d*)?$/;
  const match = strNum.match(reg);

  if (!match) {
    // 格式错误，返回原值
    return strNum;
  }

  const [, sign, integerPart, decimalPart] = match;

  // 处理整数部分千分符
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // 处理小数部分（按需保留位数）
  let processedDecimal = decimalPart || "";
  if (decimalDigits !== undefined && processedDecimal) {
    // 截取指定小数位数（四舍五入）
    const numObj = Number(`${integerPart}${processedDecimal}`);
    processedDecimal = numObj.toFixed(decimalDigits).split(".")[1] || "";
    processedDecimal = `.${processedDecimal}`;
  }

  // 拼接符号、整数、小数部分
  return `${sign}${formattedInteger}${processedDecimal}`;
};
